import { Modal, useModals } from 'almanac-ui/Modal'
import { useCallback, useEffect } from 'react'
import { ExternalIntegration } from 'api/clients/ExternalIntegrationsClient'
import Styles from './IntegrationSuccessModal.module.scss'
import { useCurrentWorkspace } from 'hooks/useCurrentWorkspace'
import { PLATFORM_DISPLAY_NAMES } from 'utils/platformDisplayNames'
import { AutopilotInfo } from './AutopilotInfo'
import { SettingScreen } from 'components/Settings/types'

interface Props {
  integration: ExternalIntegration
  onClose: (options?: { openSettingScreen?: SettingScreen }) => void
}

export const IntegrationSuccessModal = ({ integration, onClose }: Props) => {
  const { closeModal } = useModals()
  const workspace = useCurrentWorkspace()
  const isAutopilot = workspace?.is_virtual_marketer
  const showModal = isAutopilot && workspace.is_virtual_marketer_onboarding_completed

  const integrationName = PLATFORM_DISPLAY_NAMES[integration.provider]

  const handleClose = useCallback(
    (options?: { openSettingScreen?: SettingScreen }) => {
      closeModal()
      onClose(options)
    },
    [closeModal, onClose],
  )

  // only show the modal if autopilot is enabled and onboarded
  useEffect(() => {
    if (!showModal) {
      onClose()
    }
  }, [showModal, onClose])

  return (
    <Modal.Root
      size="sm"
      onPressOutside={() => {}}
      onClose={handleClose}
      aria-label={`${integrationName} Account Connected Successfully`}
    >
      <Modal.Header
        variant="hero"
        heroImage="https://res.cloudinary.com/almanac/image/upload/v1755871734/blaze_assets/65cfcb6ed487608453ac773ecee3a53be5e327f9_exitid.png"
        heroImageAlt=""
        title={`Your ${integrationName} content will start autoposting!`}
        headingLevel={1}
      />
      <Modal.Content>
        <div className={Styles.content}>
          <AutopilotInfo integration={integration} onClose={handleClose} />
        </div>
      </Modal.Content>
      <Modal.Footer>
        <Modal.FooterContent slot="right">
          <Modal.FooterButton variant="primary" onPress={() => handleClose()}>
            Confirm
          </Modal.FooterButton>
        </Modal.FooterContent>
      </Modal.Footer>
    </Modal.Root>
  )
}
